import { format } from '@bilibili-maoer/web-utils'

import { FormattedTable } from '~/features/guild/components/table'
import { TableColumn, TableProps } from '~/features/guild/components/table/types'
import { RoomLogsDataTableRow } from '~/features/room/report/types'

const TableRowCellBodyHeight = 90

export type GuildReportDataTableProps = Omit<TableProps<RoomLogsDataTableRow>, 'columns'>

export const GuildReportInfoDataTable = (props: GuildReportDataTableProps) => {
  const columns: TableColumn<RoomLogsDataTableRow>[] = [
    {
      field: 'start_time',
      headerTitle: '时间',
      headerAlign: 'center',
      headerCellSx: {
        minWidth: '120px',
      },
      bodyHeight: TableRowCellBodyHeight,
      bodyCellAlign: 'center',
      renderBodyCell: (item) => format.formatUTCTime(item.row.start_time, 'YYYY-MM-DD HH:mm'),
    },
    {
      field: 'catalog_name',
      headerTitle: '分区',
      headerAlign: 'center',
      headerCellSx: {
        minWidth: '80px',
      },
      bodyHeight: TableRowCellBodyHeight,
      bodyCellAlign: 'center',
    },
    {
      field: 'end_time',
      headerTitle: '直播时长',
      headerAlign: 'center',
      headerCellSx: {
        minWidth: '120px',
      },
      bodyHeight: TableRowCellBodyHeight,
      bodyCellAlign: 'center',
      renderBodyCell: (item) => format.formatDuration(item.row.end_time - item.row.start_time, 'zh'),
    },
    {
      field: 'message_count',
      headerTitle: '消息数',
      headerAlign: 'center',
      headerCellSx: {
        minWidth: '120px',
      },
      bodyHeight: TableRowCellBodyHeight,
      bodyCellAlign: 'center',
    },
    {
      field: 'accumulation',
      headerTitle: '累计人数',
      headerAlign: 'center',
      headerCellSx: {
        minWidth: '120px',
      },
      bodyHeight: TableRowCellBodyHeight,
      bodyCellAlign: 'center',
    },
    {
      field: 'max_score',
      headerTitle: '最高热度',
      headerAlign: 'center',
      headerCellSx: {
        minWidth: '120px',
      },
      bodyHeight: TableRowCellBodyHeight,
      bodyCellAlign: 'center',
    },
    {
      field: 'avg_score',
      headerTitle: '平均热度',
      headerAlign: 'center',
      headerCellSx: {
        minWidth: '120px',
      },
      bodyHeight: TableRowCellBodyHeight,
      bodyCellAlign: 'center',
    },
  ]

  return (
    <FormattedTable
      columns={columns}
      rows={props.rows}
      page={props.page}
      count={props.count}
      onChange={props.onChange}
    />
  )
}
